import React, { useEffect, useState } from 'react'
import { Chart } from './chart'
import { config } from './config'
import './styles.scss'

export const EasyChart: React.FC<EasyChart> = ({ data, x, y, heights }) => {
  return <>{data && <Chart data={data} x={x} y={y} heights={heights} />}</>
}
